module.exports = __webpack_public_path__ + "img/clip.08f34daa.png";